import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { navigateTo } from 'store/state/router/actions';
import { useLocale } from 'locale';
import { CompletionType, IAutocompleteEntry } from 'utils/entities';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { Actions } from 'downshift';
import { NavigateToFn, Route, State as RouteState } from 'config/routes';
import { CompletionListGroup, config as completionConfig } from 'components/commute-popup/CompletionTypeConfig';
import { InputWrapper } from 'screens/HomePageCommercial/sections/styled';
import AddressAutocompleteInput from 'components/autocomplete/single-location-autocomplete';
import LocationIcon from 'assets/svg/location-gallery.svg';
import { AddressAutocompleteSource } from 'components/autocomplete/types';
import SearchIcon from 'assets/svg/developer/search.svg';
import * as Styled from 'screens/DevelopersSearchPage/developers-search/search/styled';
import { State } from 'store/state';
import { routeSelector } from 'store/state/selectors/router';


interface SearchProps {
  route: RouteState;
  navigate: NavigateToFn;
}

const MAX_RESULTS = 5;

const Search: React.FC<SearchProps> = (props) => {
  const { t } = useLocale();
  const [ searchStr, setSearchStr ] = useState<string>('');
  const [ suggestions, setSuggestions ] = useState<IAutocompleteEntry[]>();
  const downshiftRef = useRef<Actions<IAutocompleteEntry>>(null);
  const mediaBreakpoint = useScreenBreakpoint();
  const isMobile = mediaBreakpoint <= 2;
  const { navigate, route } = props;
  const completionTypes = completionConfig[CompletionListGroup.DevelopersSearch];

  const handleAutocompleteChange = (input: IAutocompleteEntry, idx?: number) => {
    if (!input) return;

    if (input.type === CompletionType.City) {
      const { params } = route || {};
      const resetPage = idx !== -1;
      const page = resetPage ? undefined : params.page;
      navigate(Route.DevelopersCitySearchPage, { ...params, id: input.docId, page });
    }
    else {
      navigate(Route.DeveloperPage, { id: input.id });
    }
  };

  const handleSearchButton = () => {
    if (suggestions[0]) {
      handleAutocompleteChange(suggestions[0]);
    }
  };

  return (
    <Styled.SearchRoot>
      <InputWrapper isMobile={isMobile} >
        <AddressAutocompleteInput
          showType
          downshiftRef={downshiftRef}
          disableHebrewLayoutConvert
          optionsCount={MAX_RESULTS}
          completionTypes={completionTypes}
          searchStr={searchStr}
          onSearchStrChange={setSearchStr}
          placeholder={t('developersSearchPage.autocomplete.placeholder')}
          inputIcon={<LocationIcon width={20} height={20}/>}
          onChange={handleAutocompleteChange}
          onSuggest={setSuggestions}
          source={AddressAutocompleteSource.DeveloperSearch}
          initialValue={null}
          useApi3AutocompleteWithApi2
        />
      </InputWrapper>
      <Styled.SearchButton onClick={handleSearchButton}>
        <SearchIcon style={{ verticalAlign: 'middle', marginLeft: 8 }}/>
        {t('developersSearchPage.autocomplete.searchButton')}
      </Styled.SearchButton>
    </Styled.SearchRoot>
  );
};

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
});

const mapDispatchToProps = {
  navigate: navigateTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
